
export default class DatosDeTabla {
    constructor(){
        this.page=0;
        this.lastSearchText="";
        this.lastOrderBy ={"field":"", "direction":""};
        this.promise=null;
        this.query=null;
        this.header=null;
        this.service=null;
    }

    setQuery(_query){ this.query=_query }
    setHeader(_header){ this.header= _header }
    setService(_service){ this.service= _service }

    setPage(){
        this.page=(this.lastSearchText=== this.query.search) ? this.query.page  : 0;
        if (this.query.orderBy!==undefined) {
            if (this.query.orderBy.field!==this.lastOrderBy.field || this.query.orderDirection !== this.lastOrderBy.direction){
                this.page=0;
            }
        }
    }

    setLastOrderBy(){
        if (this.query.orderBy===undefined) this.lastOrderBy={"field":"", "direction":""};
        else this.lastOrderBy={"field":this.query.orderBy.field, "direction":this.query.orderDirection};
    }

    setLastSearchText() { this.lastSearchText= this.query.search }

    setSearchCriteria(){
        this.service.metodoDeBusqueda.clear();
        this.service.metodoDeBusqueda.setOperator("or");
        let self = this;
        if (this.query.search.length>0){
            this.header.forEach(function(item) {
                self.service.metodoDeBusqueda.addContains(item.field, self.query.search);
            });
        }

        if (this.service.iniciarMetodoDeBusqueda!==null){
            this.service.iniciarMetodoDeBusqueda.get().forEach(function(item) {
                self.service.metodoDeBusqueda.setOperator(item.operator);
                self.service.metodoDeBusqueda.add(item.id, item.option, item.value);
            });
        }
    }

    setOrderCriteria(){
        this.service.metodoDeOrden.clear();
        if (this.query.orderBy!==undefined) this.service.metodoDeOrden.add(this.query.orderBy.field,  this.query.orderDirection);
        let self = this;
        if (this.service.iniciarMetodoDeOrden!==null){
            this.service.iniciarMetodoDeOrden.get().forEach(function(item) {
                self.service.metodoDeOrden.add(item.id, item.option);
            });
        }
    }

    async setPromise(){
        try{
            let result = await this.service.setearPagina(this.page, this.query.pageSize);
            this.service.metodoDeBusqueda.clear();
            this.promise= new Promise((resolve) => {
                if (result.error!==null) resolve({ data: [], page: 0, totalCount: 0});
                else if (result.data===null)    resolve({ data: [], page: 0 , totalCount: 0});
                else resolve({ data: result.data.content, page: result.data.number , totalCount: result.data.totalElements});
            });
        }catch(error){
            this.promise= new Promise((resolve) => {
                resolve({ data:[], page: 0 , totalCount: 0});
            });
        }
    }

    async getPromiseResponse(){
        this.setPage();
        this.setLastOrderBy();
        this.setLastSearchText();
        this.setSearchCriteria();
        this.setOrderCriteria();
        await this.setPromise();
        return this.promise
    };
}